import React, { Fragment } from 'react';
import { Transition } from 'react-transition-group';
import { TransitionStatus } from 'react-transition-group/Transition';
import cn from 'classnames';

import { OddFormatSelect } from '../OddFormatSelect';
import { OddsStatisticSelect } from '../OddsStatisticSelect';
import SettingsToggler from '../SettingsToggler';
import ToggleHistory from '../ToggleHistory';
import useSettingsMenu from './useSettingsMenu';

import './settingsMenu.scss';

const SettingsMenu: React.FC = () => {
    const {
        isOpen,
        onClickHandler,
        isAnimationFinished,
        setIsAnimationFinished,
    } = useSettingsMenu();

    return (
        <div styleName="container">
            <Transition
                in={isOpen}
                timeout={500}
                mountOnEnter={false}
                unmountOnExit={false}
                onEntered={() => setIsAnimationFinished(true)}
            >
                {(transition: TransitionStatus) => (
                    <div
                        styleName={cn('settings-wrapper', {
                            'is-open': isOpen,
                            'animation-finished': isAnimationFinished,
                        })}
                    >
                        <div styleName="settings">
                            <SettingsToggler
                                onClickHandler={onClickHandler}
                                isOpen={isOpen}
                            />
                            {transition !== 'exited' && (
                                <Fragment>
                                    <OddFormatSelect />
                                    <ToggleHistory />
                                    <OddsStatisticSelect />
                                </Fragment>
                            )}
                        </div>
                    </div>
                )}
            </Transition>
        </div>
    );
};

export default React.memo(SettingsMenu);
